export default {
    namespaced: true,
    state: {
        insertMaterials: [],
        supplierInsertMaterials: [],
        insertColors: [],
        insertFacets: [],
        errors: {
            getInsertMaterials: '',
            getInsertColors: '',
            getInsertFacets: ''
        }
    },
    getters: {
        //values for supplier products page filter, default all
        supplierInsertMaterialsValuesArr(state) {
            return state.supplierInsertMaterials.map(
                material => material.MaterialID
            )
        },
        nameInsertMaterial: state => id => {
            const material = state.insertMaterials.find(item => {
                return parseInt(item.MaterialID) === parseInt(id)
            })

            return material ? material.Name : ''
        },
        nameInsertColor: state => id => {
            const material = state.insertColors.find(item => {
                return parseInt(item.ColorID) === parseInt(id)
            })

            return material ? material.Name : ''
        },
        nameInsertFacet: state => id => {
            const material = state.insertFacets.find(item => {
                return parseInt(item.FacetID) === parseInt(id)
            })

            return material ? material.Name : ''
        }
    },
    mutations: {
        SET_INSERT_MATERIALS(state, payload) {
            state.insertMaterials = payload
        },
        SET_SUPPLIER_INSERT_MATERIALS(state, payload) {
            state.supplierInsertMaterials = payload
        },
        SET_INSERT_COLORS(state, payload) {
            state.insertColors = payload
        },
        SET_INSERT_FACETS(state, payload) {
            state.insertFacets = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getInsertMaterials({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getInsertMaterials',
                val: ''
            })

            const url = '/public/dict/insert/materials'

            try {
                const resp = await this.$axios
                    .get(url, {
                        params: data
                    })
                    .then(res => {
                        return res.data
                    })

                if (data && data.existing) {
                    commit('SET_SUPPLIER_INSERT_MATERIALS', resp)
                } else {
                    commit('SET_INSERT_MATERIALS', resp)
                }
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getInsertMaterials',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getInsertMaterials',
                        val: 'Ошибка'
                    })
                }
            }
        },
        async getInsertColors({ commit }) {
            commit('SET_ERRORS', {
                key: 'getInsertColors',
                val: ''
            })

            const url = '/public/dict/insert/colors'

            try {
                const resp = await this.$axios.get(url).then(res => {
                    return res.data
                })

                commit('SET_INSERT_COLORS', resp)
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getInsertColors',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getInsertColors',
                        val: 'Ошибка'
                    })
                }
            }
        },
        async getInsertFacets({ commit }) {
            commit('SET_ERRORS', {
                key: 'getInsertFacets',
                val: ''
            })

            const url = '/public/dict/insert/facets'

            try {
                const resp = await this.$axios.get(url).then(res => {
                    return res.data
                })

                commit('SET_INSERT_FACETS', resp)
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getInsertFacets',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getInsertFacets',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
